import React, { FC } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { setPath } from '../../../utils/url'
import { URL } from '../../constants/url'
import { Link, useParams } from 'react-router-dom'
import { isManager } from '../../../utils/role'

type LangValue = 'ja' | 'en'

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

const SideBarSubSearch: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const { language } = useParams<{ language: LangValue }>()

  return (
    <>
      {
        location.pathname.match(URL.SEARCH.path) ? (
          <div className="side_sub_wrap">
            <div className="tools">
              <div className="calendar_text">
                <div />
                <button
                  type="button"
                  className={`menu_toggle ${isOpen && "display"}`}
                  onClick={() => toggleCallback()}
                >
                  <div className={`menu ${isOpen && "active"}`}>
                    <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                  </div>
                </button>
              </div>
            </div>
            <section className="side_sub">
              {
                (
                  login.function_enabled_state?.ai_work_assessment
                  || (
                    login.function_enabled_state?.organizational_analysis
                    && isManager(login.role)
                  )
                ) && (
                  <Link
                    to={setPath(URL.SEARCH.path, language)}
                    className={classNames({
                      active: location.pathname.match(URL.SEARCH.path) && location.pathname.split("/").length === 3,
                      item: true,
                    })}
                  >
                    <div className="name_label">
                      <FontAwesomeIcon
                        icon={['fas', 'angle-right']}
                        className="arrow_icon"
                      />
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'search']}
                          className="icon task"
                        />
                        全体検索
                      </div>
                    </div>
                  </Link>
                )
              }
              {/* {
                login.function_enabled_state?.task_management_approval
                && (
                  <Link
                    to={setPath(URL.SEARCH_TASK.path, language)}
                    className={classNames({
                      active: location.pathname.match(URL.SEARCH_TASK.path),
                      item: true,
                    })}
                  >
                    <div className="name_label">
                      <FontAwesomeIcon
                        icon={['fas', 'angle-right']}
                        className="arrow_icon"
                      />
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'wrench']}
                          className="icon task"
                        />
                        工数管理検索
                      </div>
                    </div>
                  </Link>
                )
              } */}
            </section>
          </div>
        ) : (
          <>
          </>
        )
      }
    </>
  )
}

export default SideBarSubSearch
